import React from 'react';

export default function FeatureCard({
  title,
  description,
  desktopImage,
  mobileImage,
  alt,
}) {
  return (
    <div className='relative sm:rounded-2xl overflow-hidden flex items-end transition-all duration-300 h-[25rem] sm:h-[16.25rem] max-w-xl md:max-w-none w-full'>
      <div className='absolute inset-0 bg-gradient-to-r from-white/1 via-white/3 to-white/1' />
      <div className='absolute inset-0'>
        <img
          src={desktopImage}
          alt={alt}
          className='w-full h-full object-cover opacity-80 transition-opacity duration-300 hidden sm:block'
        />
        <img
          src={mobileImage}
          alt={alt}
          className='w-full h-full object-cover opacity-80 transition-opacity duration-300 block sm:hidden'
        />
      </div>

      <div
        className='relative z-10 p-4 text-left text-base md:text-13'
        style={{
          background:
            'linear-gradient(0deg, #071A19 0%, rgba(7, 26, 25, 0.72) 75.48%, rgba(7, 26, 25, 0.00) 100%)',
        }}
      >
        <h3 className='font-semibold text-white mb-2'>{title}</h3>
        <p className='text-white/60 leading-none'>{description}</p>
      </div>
    </div>
  );
}
